import router from "../../router";
import axios from 'axios';
const noretryAuthAxios = axios.create();
noretryAuthAxios.defaults.baseURL = 'https://api.piachu.net/';

//const state = {
//};
 
//const mutations = {
//};

const actions = {

    async put_order ({ commit }, payload) {
        await new Promise((resolve, reject) => {
            axios.put('/api/order', {
                order: payload.order
            }).then(res => {
                resolve(res);
            }).catch(error => {
                reject(error);
            });
        });
    },

    async get_test_bullet ({ commit }, payload) {
        return new axios.get('/api/order/test_bullet')
        .catch(error => {
            reject(error);
        })
    },

    async check_test_bullet ({ commit }, payload) {
        return new axios.get('/api/order/check_test_bullet?products_id='+payload.products_id)
        .catch(error => {
            reject(error);
        })
    },

    async post_test_bullet ({ commit }, payload) {
        await new Promise((resolve, reject) => {
            axios.post('/api/order/test_bullet', {
                "order": payload.sendForm,
            }).then(res => {
                resolve(res);
            }).catch(error => {
                reject(error);
            });
        });
    },

    async get_buy ({ commit }, payload) {
        return new axios.get('/api/order/buy')
        .catch(error => {
            reject(error);
        })
    },

    async get_payment ({ commit }, payload) {
        return new axios.get('/api/order/payment')
        .catch(error => {
            reject(error);
        })
    },

    async check_buy ({ commit }, payload) {
        return new axios.get('/api/order/check_buy?products_id='+payload.products_id)
        .catch(error => {
            reject(error);
        })
    },

    async post_buy ({ commit }, payload) {
        await new Promise((resolve, reject) => {
            axios.post('/api/order/buy', {
                "order": payload.sendForm,
            }).then(res => {
                resolve(res);
            }).catch(error => {
                reject(error);
            });
        });
    },

    async get_billing ({ commit }, payload) {
        return new axios.get('/api/order/billing?year='+payload.year+'&month='+payload.month)
        .catch(error => {
            reject(error);
        })
    },

    async search_order ({ commit }, payload) {
        let params = "?admin=1";
        if ( payload.searchForm != null ) {
            if ( payload.searchForm.buyer_name != "" ) {
                params += "&buyer_name="+payload.searchForm.buyer_name;
            }
            if ( payload.searchForm.seller_name != "" ) {
                params += "&seller_name="+payload.searchForm.seller_name;
            }
            if ( payload.searchForm.seller_mail != "" ) {
                params += "&seller_mail="+payload.searchForm.seller_mail;
            }
            if ( payload.searchForm.payment_status != "" ) {
                params += "&payment_status="+payload.searchForm.payment_status;
            }
            if ( payload.searchForm.status != "" ) {
                params += "&status="+payload.searchForm.status;
            }
        }
        return new axios.get('/api/order/search'+params)
        .catch(error => {
            reject(error);
        })
    },

    async get_admin_order ({ commit }, payload) {
        return new axios.get('/api/order_detail/admin?orders_id='+payload.order_id)
        .catch(error => {
            reject(error);
        })
    },

    async put_admin_review ({ commit }, payload) {
        await new Promise((resolve, reject) => {
            axios.put('/api/review/admin', {
                id: payload.id,
                contents: payload.contents,
                comment: payload.comment,
                review_comment_id: payload.review_comment_id,
                review_comment_contents: payload.review_comment_contents,
            }).then(res => {
                resolve(res);
            }).catch(error => {
                reject(error);
            });
        });
    },



















    async current_price ({ commit }, payload) {
        return await axios.post('/api/usage_price/current_price', {
            "user_type": payload.user_type,
            "test_order_flg": payload.test_order_flg,
            "date": payload.date,
        }).then(res => {
            return res;
        }).catch(error => {
            return error;
        });
    },

};

export default {
    namespaced: true,
//    state,
//    mutations,
    actions
};



// WEBPACK FOOTER //
// ./src/store/modules/order.js